module.exports = __webpack_public_path__ + "static/media/pwa.c633daf4.jpg";